import Vue from 'vue'

// Components

// Importing Core layout component
import Header from './core/Header'
import Menu from './core/Menu'
import View from './core/View.vue'
import Footer from './core/Footer.vue'

// Importing Custom Components
import BannerOwlCard from './material/BannerCarousel'
import OfferOwlCarousel from './material/OfferOwlCarousel'
import CategoryCard from './material/CategoryCard'

// Registered  core Components
Vue.component('core-header', Header)
Vue.component('core-menu', Menu)
Vue.component('core-view', View)
Vue.component('core-footer', Footer)

// Registered Components
Vue.component('banner-slider', BannerOwlCard)
Vue.component('offer-owl-carousel', OfferOwlCarousel)
Vue.component('category-card', CategoryCard)

export {

  // core part
  Header,
  Menu,
  View,
  Footer,

  // others
  BannerOwlCard,
  OfferOwlCarousel,
  CategoryCard

}
